var map = {
	"./audio/ringtone.mp3": 406,
	"./images/anytime-anywhere.svg": 1434,
	"./images/app-store-badge.svg": 624,
	"./images/assessment.png": 248,
	"./images/assessment.svg": 1435,
	"./images/babylon_us_ios_app.png": 207,
	"./images/card-payment.jpg": 1436,
	"./images/check-bullet.svg": 1437,
	"./images/icon_gcal.png": 1422,
	"./images/icon_ical.png": 1423,
	"./images/icon_outlook.png": 1424,
	"./images/injection-instructions/global-checkin-norefill.mp4": 683,
	"./images/injection-instructions/wegovy-cap-pen.mp4": 680,
	"./images/injection-instructions/wegovy-check-clarity.mp4": 668,
	"./images/injection-instructions/wegovy-check-dose.mp4": 551,
	"./images/injection-instructions/wegovy-check-flow-for-drop.mp4": 674,
	"./images/injection-instructions/wegovy-check-flow.mp4": 673,
	"./images/injection-instructions/wegovy-choose-injection-site.mp4": 676,
	"./images/injection-instructions/wegovy-clean-the-injection-site.mp4": 677,
	"./images/injection-instructions/wegovy-drop-or-not.mp4": 675,
	"./images/injection-instructions/wegovy-inject-allsteps-waist.mp4": 678,
	"./images/injection-instructions/wegovy-inject-remove-needle.mp4": 679,
	"./images/injection-instructions/wegovy-innercap-remove.mp4": 672,
	"./images/injection-instructions/wegovy-needle-box-and-paper-off.mp4": 669,
	"./images/injection-instructions/wegovy-outercap-remove.mp4": 671,
	"./images/injection-instructions/wegovy-pencap-remove.mp4": 667,
	"./images/injection-instructions/wegovy-pencap-replace.mp4": 682,
	"./images/injection-instructions/wegovy-remove-needle.mp4": 681,
	"./images/injection-instructions/wegovy-twist-on-needle.mp4": 670,
	"./images/lifestyle-health.svg": 1438,
	"./images/logo/ask-a-and-e--square.png": 1439,
	"./images/logo/ask-a-and-e.png": 1440,
	"./images/logo/babylon--square.png": 1441,
	"./images/logo/babylon-brazil-einstein--square.png": 1442,
	"./images/logo/babylon-brazil-einstein.png": 1443,
	"./images/logo/babylon.png": 1444,
	"./images/logo/bupa.png": 1445,
	"./images/logo/columbus-direct.png": 1446,
	"./images/logo/eMed-heart.png": 650,
	"./images/logo/gp-at-hand.png": 1447,
	"./images/logo/nhs-rwt.png": 1448,
	"./images/logo/nhs-services.png": 1449,
	"./images/logo/nhs-uhb-ed.png": 1450,
	"./images/logo/nhs.png": 1451,
	"./images/logo/none.png": 1452,
	"./images/logo/united-healthcare.png": 1453,
	"./images/logo_square.png": 1420,
	"./images/map-pin-blank.svg": 1425,
	"./images/map-pin-generic.svg": 1426,
	"./images/map-pin-pharmacy.svg": 1421,
	"./images/nhs-logo.svg": 1427,
	"./images/ozempic-inject-allsteps-waist.mp4": 666,
	"./images/play-store-badge.svg": 625,
	"./images/waves.svg": 1454,
	"./images/weight-loss_clinician-call.jpg": 664,
	"./images/weight-loss_female-doctor.jpg": 658,
	"./images/weight-loss_get-your-medication.jpg": 659,
	"./images/weight-loss_gym.jpg": 657,
	"./images/weight-loss_hands.png": 309,
	"./images/weight-loss_lose-weight.jpg": 660,
	"./images/weight-loss_person-on-scales.jpg": 407,
	"./images/weight-loss_scale.png": 308,
	"./images/weight-loss_science.jpg": 1455,
	"./images/weight-loss_syringe.png": 307,
	"./images/weight-loss_video.png": 1456,
	"./images/weight-loss_wegovy.jpg": 310,
	"./images/welcome_screen.jpg": 654,
	"./info-icon.svg": 1457,
	"./logo_heart.png": 1458,
	"./logo_heart_small.png": 1459
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
}
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e(/* lazy-once context */ 35).then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 1176;
module.exports = webpackAsyncContext;